module.exports = "<div class=\"c-profile__section c-profile__reviews\">\n    <div class=\"c-profile__section_intro c-profile__reviews_intro\">\n        <h2>Notifications</h2>\n    </div>\n    <div class=\"c-profile__section_content c-profile__reviews_content\">\n        <h5 class=\"t-center\">No new notifications found</h5>\n    </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/user/notifications.component.html
// module id = ./src/app/user/notifications.component.html
// module chunks = main